<template>
  <div>
    <main class="list-table mt-5">
      <div class="row">
        <div class="col-md-12">
          <div class="form d-flex align-items-center">
            <Json2Csv
              class="ml-auto"
              v-if="items.length > 0"
              :json-data="csvData"
              :csv-title="`Lost_Items_Historical`"
            >
              <button class="btn btn-download">
                {{ $t("lostItems.btnDownload") }}
              </button>
            </Json2Csv>
          </div>
        </div>
      </div>
      <v-client-table
        v-if="items"
        :columns="table_options.columns"
        :options="table_options.options"
        :data="items"
      >
        <!-- Actions -->
        <template v-slot:actions="props">
          <div class="actions">
            <!-- Edit -->

            <!-- Delete -->
            <!-- Detalles-->
            <router-link
              class="details"
              :class="props.row.status === 'deleted' ? 'disable' : ''"
              :to="{
                name: 'Lost Item Detail',
                params: {
                  id: props.row.id,
                  object: props.row,
                  details: true
                }
              }"
            >
              <i class="far fa-eye"></i>
            </router-link>
          </div>
        </template>
      </v-client-table>
    </main>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/lostItems.js";
const api = new API_SERVICE();
import Json2Csv from "vue-json-to-csv";

export default {
  components: {
    Json2Csv
  },
  data() {
    return {
      items: null,
      folio: "",
      page: 0,
      categories: [],
      resolution: "",
      csvData: null,
      dictionary: {
        folio: this.$t("lostItems.tabs.Historical.table.headings.folio"),
        itemInfo: this.$t("lostItems.tabs.Historical.table.headings.itemInfo"),
        inventoriedBy: this.$t(
          "lostItems.tabs.Historical.table.headings.inventoriedBy"
        ),
        collector: this.$t(
          "lostItems.tabs.Inventoried.table.headings.collector"
        ),
        category: this.$t("lostItems.tabs.Historical.table.headings.category"),
        resolvedBy: this.$t(
          "lostItems.tabs.Historical.table.headings.resolvedBy"
        ),
        resolution: this.$t(
          "lostItems.tabs.Historical.table.headings.resolution"
        )
      }
    };
  },
  async beforeMount() {
    await this.getCategory();
    await this.getItems();
  },
  methods: {
    getItems: async function() {
      this.$store.commit("global/SET_LOADING", true);
      let queries = {
        page: this.page,
        limit: 999999,
        published: false,
        status: ""
      };
      try {
        let items = [];
        const resp = await api.getLostItemsByStatus(queries);
        items = resp.result.result;
        this.items = items.map(item => {
          let category = this.categories.filter(
            cat => item.categoryId === cat.id
          );
          category = category.length > 0 ? category[0].name : "";
          item.category = category;
          switch (item.resolution) {
            case "delivered":
              item.resolution = this.$t("lostItems.lostItemDetail.delivery");
              break;
            case "donated":
              item.resolution = this.$t("lostItems.lostItemDetail.donated");
              break;
            case "destroyed":
              item.resolution = this.$t("lostItems.lostItemDetail.destroyed");
              break;
            default:
              break;
          }
          if (item.status === "deleted") {
            item.resolution = this.$t("lostItems.lostItemDetail.deleted");
          }
          return item;
        });
        this.itemsToDownload();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    getCategory: async function() {
      let currentLanguage = localStorage.getItem("lang");

      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getLostItemsCategorys(currentLanguage);
        this.categories = resp.categories;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    itemsToDownload: function() {
      const itemsFields = [
        "folio",
        "itemInfo",
        "inventoriedBy",
        "collector",
        "category",
        "resolvedBy",
        "resolution"
      ];

      let downloadArray = this.items.map(item => {
        let obj = {};
        itemsFields.forEach(field => {
          obj[this._translateHeader(field)] = item[field] ? item[field] : "";
        });
        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    }
  },
  computed: {
    table_options: function() {
      return {
        columns: [
          "folio",
          "itemInfo",
          "category",
          "collector",
          "inventoriedBy",
          "resolvedBy",
          "resolution",
          "actions"
        ],
        options: {
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            folio: this.$t("lostItems.tabs.Historical.table.headings.folio"),
            itemInfo: this.$t(
              "lostItems.tabs.Historical.table.headings.itemInfo"
            ),

            category: this.$t(
              "lostItems.tabs.Historical.table.headings.category"
            ),
            collector: this.$t(
              "lostItems.tabs.Historical.table.headings.collector"
            ),
            inventoriedBy: this.$t(
              "lostItems.tabs.Historical.table.headings.inventoriedBy"
            ),

            resolvedBy: this.$t(
              "lostItems.tabs.Historical.table.headings.resolvedBy"
            ),

            resolution: this.$t(
              "lostItems.tabs.Historical.table.headings.resolution"
            ),
            actions: this.$t("lostItems.tabs.Historical.table.headings.actions")
          },
          sortable: [
            "folio",
            "itemInfo",
            "category",
            "collector",
            "inventoriedBy",
            "resolvedBy"
          ],
          filterable: ["itemInfo"],
          perPage: 10,
          resizableColumns: false,
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          columnsClasses: {
            folio: "folio-col",
            itemInfo: "itemInfo-col",
            category: "category-col",
            collector: "collector-col",
            resolvedBy: "resolvedBy-col",
            inventoriedBy: "inventoriedBy-col",
            resolution: "resolution-col",
            actions: "actions-col"
          }
          // cellClasses: {
          //   folio: [
          //     {
          //       class: "disable",
          //       condition: row => (row.status = "deleted")
          //     }
          //   ]
          // }
        }
      };
    },
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    }
  }
};
</script>

<style lang="scss">
.actions {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actions > * {
  cursor: pointer;
}
.actions > .edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: $black;
  }
}
</style>
<style>
.form-inline label {
  display: initial;
}
.disable {
  color: #aaaaaa !important;
  pointer-events: none !important;
}
.btn-download {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0px !important;
}
td {
  text-align: left !important;
  vertical-align: middle !important;
}
#VueTables_th--folio,
#VueTables_th--itemInfo {
  width: 200px !important;
}
#VueTables_th--categoryAndStatus,
#VueTables_th--folioAndStatus {
  width: 400px !important;
}
#VueTables_th--actions,
#VueTables_th--placeCollection,
#VueTables_th--collector,
#VueTables_th--userName,
#VueTables_th--inventoryDate #VueTables_th--inventoriedBy,
#VueTables_th--resolutionAction,
#VueTables_th--category,
#VueTables_th--resolvedBy,
#VueTables_th--resolution {
  width: 210px !important;
}
#VueTables_th--dateCollection {
  width: 300px !important;
}
</style>
